/// <amd-module name="Build/Extensions/Bitbucket/ConnectionList" />
import * as React from "react";

import { ServiceConnectionInfo } from "Build/Extensions/Connection-Services/ServiceConnectionRetrieverService";

import { IWizardListItem, WizardList } from "Build/Designer/WizardList";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

interface ConnectionListProps {
    showConnections: boolean;
    serviceConnections: ServiceConnectionInfo[];
    getItemPrimaryText: (serviceConnectionInfo: ServiceConnectionInfo) => string;
    getItemSecondaryText: (serviceConnectionInfo: ServiceConnectionInfo) => string;
    onSelectConnection: (connectionId: string) => void;
}

export class ConnectionList extends VssComponent<ConnectionListProps, {}, IVssComponentContext> {
    constructor(props: ConnectionListProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        const hasConnections: boolean = (this.props && this.props.serviceConnections && this.props.serviceConnections.length > 0);
        if (!this.props.showConnections || !hasConnections) {
            return <div />;
        }

        const wizardListItems: IWizardListItem[] = this.props.serviceConnections.map(
            s => {
                return {
                    name: this.props.getItemPrimaryText(s),
                    description: this.props.getItemSecondaryText(s),
                    iconUrl: s.imageUrl || getAssetLocation(this.context.pageContext, "ms.vss-build-web/designer-bitbucket/Content/bitbucket.svg")
                };
            }
        )

        return (
            <WizardList
                wizardListItems={wizardListItems}
                onClick={(_, data) => {
                    this.props.onSelectConnection(this.props.serviceConnections[data.index].id);
                }}
            />
        );
    }
}
